import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "8 6 10 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"8 6 10 12\" id=\"play\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m10 15.098 4.867-3.102L10 8.894v6.204ZM8 6.747v10.497c0 .618.83.971 1.412.6l8.235-5.248c.47-.3.47-.9 0-1.2L9.412 6.147C8.83 5.777 8 6.13 8 6.747Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol